/**
 * Linkify message body for chat bubbles — turn URLs into safe <a>
 * elements without invoking dangerouslySetInnerHTML.
 *
 * Returns an array of React-friendly tokens (string for text, object
 * for link) so the caller can map to JSX. Pure function → easily
 * testable.
 *
 * Security:
 *   - Only http(s):// matched (no `javascript:` etc.)
 *   - URL is rendered as plain text via React (no innerHTML), so even
 *     a maliciously-crafted URL display can't inject HTML
 *   - rel="noopener noreferrer" on every link
 */

const URL_RE =
  /(\bhttps?:\/\/[\w\-._~:/?#[\]@!$&'()*+,;=%]+[\w\-/?#@!$&()*+;=%])/g;

export type LinkifyToken =
  | { type: 'text'; value: string }
  | { type: 'link'; value: string };

export function linkify(body: string): LinkifyToken[] {
  if (!body) return [{ type: 'text', value: '' }];
  const out: LinkifyToken[] = [];
  let lastIdx = 0;
  for (const m of body.matchAll(URL_RE)) {
    const idx = m.index ?? 0;
    if (idx > lastIdx) {
      out.push({ type: 'text', value: body.slice(lastIdx, idx) });
    }
    out.push({ type: 'link', value: m[0] });
    lastIdx = idx + m[0].length;
  }
  if (lastIdx < body.length) {
    out.push({ type: 'text', value: body.slice(lastIdx) });
  }
  return out.length > 0 ? out : [{ type: 'text', value: body }];
}
